import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllotmentsComponent } from './allotments/allotments.component';
import { UniversitiesComponent } from './data-management/universities/universities.component';
import { StudentsComponent } from './data-management/students/students.component';
import { HomeComponent } from './home/home.component';
import { ReportsComponent } from './reports/reports.component';
import {PageNotFoundComponent} from './not-found.component';
import {FinalReportsComponent} from './reports/final-reports/final-reports.component';
import {LoginComponent} from './login/login.component';
import {OutgoingStudentGuard} from './guards/outgoing-student.guard';
import {AuthGuard} from './guards/auth.guard';
import {OiaGuard} from './guards/oia.guard';
import {OiaOrEcGuard} from './guards/oia-or-ec.guard';
import {AccessDeniedComponent} from './access-denied';
import {ApplicationFormComponent} from './application-form/application-form.component';
import {ApplicationFormIncomingComponent} from './application-form-incoming/application-form-incoming.component';
import {DataManagementComponent} from './data-management/data-management.component';
import {UtilityComponent} from './utility/utility.component';
import {ProgrammesComponent} from './data-management/programmes/programmes.component';
import {RoundSettingsComponent} from './allotments/round-settings/round-settings.component';
import {ResultsComponent} from './bidding-settings/results/results.component';
import {ManualAllotmentsComponent} from './allotments/manual-allotments/manual-allotments.component';
import {AnnouncementsComponent} from './utility/announcements/announcements.component';
import {EmailTemplatesComponent} from './utility/email-templates/email-templates.component';
import {DocumentsComponent} from './utility/documents/documents.component';
import {IncomingStudentsComponent} from './data-management/incoming-students/incoming-students.component';
import {NominationsComponent} from './nominations/nominations.component';
import {PastStudentsComponent} from './past-students/past-students.component';
import {CourseBiddingComponent} from './course-bidding/course-bidding.component';
import {CourseComponent} from './course/course.component';
import {TermScheduleComponent} from './term-schedule/term-schedule.component';
import {IncomingActionsComponent} from './in-out-actions/incoming-actions/incoming-actions.component';
import {OutgoingActionsComponent} from './in-out-actions/outgoing-actions/outgoing-actions.component';
import {IncomingTermScheduleComponent} from './term-schedule/incoming-term-schedule/incoming-term-schedule.component';
import {OutgoingTermScheduleComponent} from './term-schedule/outgoing-term-schedule/outgoing-term-schedule.component';
import {InOutActionsComponent} from './in-out-actions/in-out-actions.component';
import {ActionsComponent} from './utility/actions/actions.component';
import {BiddingComponent} from './bidding-settings/bidding.component';
import {ViewRoundsComponent} from './bidding-settings/view-rounds/view-rounds.component';
import {ModifyRoundsComponent} from './bidding-settings/modify-rounds/modify-rounds.component';
import {StudentBiddingComponent} from './student-bidding/student-bidding.component';
import {PracticeRoundComponent} from './bidding-rounds/practice-round/practice-round.component';
import {BiddingRoundsComponent} from './bidding-rounds/bidding-rounds.component';
import {RoundOneComponent} from './bidding-rounds/round-one/round-one.component';
import {RoundTwoComponent} from './bidding-rounds/round-two/round-two.component';
import {EcGuard} from './guards/ec.guard';
import {ProcessingOutputComponent} from './bidding-settings/processing-output/processing-output.component';
import {ApplicationFormOiaComponent} from './application-form-oia/application-form-oia.component';
import {PracticeRoundReportsComponent} from './reports/practice-round-reports/practice-round-reports.component';
import {RoundTwoReportsComponent} from './reports/round-two-reports/round-two-reports.component';
import {RegistrationReportsComponent} from './reports/registration-reports/registration-reports.component';
import {RoundOneReportsComponent} from './reports/round-one-reports/round-one-reports.component';
import {DiversityReportsComponent} from './reports/diversity-reports/diversity-reports.component';
import {FeedbackFormComponent} from './feedback-form/feedback-form.component';
import {IncomingStudentGuard} from './guards/incoming-student-guard';
import {PocGuard} from './guards/poc-guard';
import {IncomingComponent} from './application-form-oia/incoming/incoming.component';
import {OutgoingComponent} from './application-form-oia/outgoing/outgoing.component';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {ConfirmationPracticeRoundComponent} from './confirmation/confirmation-practice-round/confirmation-practice-round.component';
import {ConfirmationRoundOneComponent} from './confirmation/confirmation-round-one/confirmation-round-one.component';
import {ConfirmationRoundTwoComponent} from './confirmation/confirmation-round-two/confirmation-round-two.component';
import {ConfirmationRoundThreeComponent} from './confirmation/confirmation-round-three/confirmation-round-three.component';
import {BiddingRoundTwoComponent} from './bidding-rounds/bidding-round-two/bidding-round-two.component';
import {RoundThreeComponent} from './bidding-rounds/round-three/round-three.component';
import {RoundFourComponent} from './bidding-rounds/round-four/round-four.component';
import {ConfirmationRoundFourComponent} from './confirmation/confirmation-round-four/confirmation-round-four.component';
import {PocsComponent} from './data-management/pocs/pocs.component';
import { IncomingTermVisaSettingsComponent } from './term-schedule/incoming-term-visa-settings/incoming-term-visa-settings.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { DreamUniversityReportComponent } from './reports/dream-university-report/dream-university-report.component';

const appRoutes: Routes = [
    {
        path: 'home',
        canActivate: [AuthGuard],
        component: HomeComponent,
    },
    {
        path: 'application',
        canActivate: [AuthGuard, OutgoingStudentGuard],
        component: ApplicationFormComponent,
    },
    {
        path: 'application-incoming',
        canActivate: [AuthGuard, IncomingStudentGuard],
        component: ApplicationFormIncomingComponent,
    },
    {
        path: 'course-bidding',
        canActivate: [AuthGuard, IncomingStudentGuard],
        component: CourseBiddingComponent,
    },
    {
        path: 'courses',
        canActivate: [AuthGuard, IncomingStudentGuard],
        component: CourseComponent,
    },
    {
        path: 'term-schedule',
        component: TermScheduleComponent,
        canActivate: [AuthGuard, OiaGuard],
        children: [
            {path: '', redirectTo: 'outgoing', pathMatch: 'full'},
            {path: 'incoming', component: IncomingTermScheduleComponent},
            {path: 'outgoing', component: OutgoingTermScheduleComponent},
            {path:'incoming-term-visa-settings', component:IncomingTermVisaSettingsComponent}
        ]
    },
    {
        path: 'term-schedule-ec',
        component: TermScheduleComponent,
        canActivate: [AuthGuard, EcGuard],
        children: [
            {path: '', redirectTo: 'outgoing', pathMatch: 'full'},
            {path: 'incoming', component: IncomingTermScheduleComponent},
            {path: 'outgoing', component: OutgoingTermScheduleComponent},
        ]
    },
    /*{
        path: 'actions',
        component: InOutActionsComponent,
        children: [
            {path: '', redirectTo: 'outgoing', pathMatch: 'full'},
            {path: 'incoming', component: IncomingActionsComponent},
            {path: 'outgoing', component: OutgoingActionsComponent},
        ]
    },*/
    {
        path: 'nominations',
        canActivate: [AuthGuard, PocGuard],
        component: NominationsComponent,
    },
    {
        path: 'past-students',
        canActivate: [AuthGuard, PocGuard],
        component: PastStudentsComponent,
    },
    {
        path: 'application-oia',
        canActivate: [AuthGuard, OiaGuard],
        component: ApplicationFormOiaComponent,
        children: [
            {path: '', redirectTo: 'outgoing', pathMatch: 'full'},
            {path: 'incoming', component: IncomingComponent},
            {path: 'outgoing', component: OutgoingComponent},
        ]
    },
    {
        path: 'application-ec',
        canActivate: [AuthGuard, EcGuard],
        component: ApplicationFormOiaComponent,
        children: [
            {path: '', redirectTo: 'outgoing', pathMatch: 'full'},
            {path: 'incoming', component: IncomingComponent},
            {path: 'outgoing', component: OutgoingComponent},
        ]
    },
    {
        path: 'student-bidding-settings',
        component: StudentBiddingComponent,
    },
    {
        path: 'documents',
        canActivate: [AuthGuard],
        component: DocumentsComponent,
    },
    {
        path: 'round-2',
        component: RoundTwoComponent,
    },
    {
        path: 'data',
        component: DataManagementComponent,
        canActivate: [AuthGuard, OiaGuard],
        children: [
            {path: '', redirectTo: 'universities', pathMatch: 'full'},
            {path: 'universities', component: UniversitiesComponent},
            {path: 'outgoing-students', component: StudentsComponent},
            {path: 'incoming-students', component: IncomingStudentsComponent},
            {path: 'programmes', component: ProgrammesComponent},
            {path: 'pocs', component: PocsComponent},
        ]
    },
    {
        path: 'data-management',
        component: DataManagementComponent,
        canActivate: [AuthGuard, EcGuard],
        children: [
            {path: '', redirectTo: 'universities', pathMatch: 'full'},
            {path: 'universities', component: UniversitiesComponent},
            {path: 'outgoing-students', component: StudentsComponent},
            {path: 'incoming-students', component: IncomingStudentsComponent},
            {path: 'programmes', component: ProgrammesComponent},
        ]
    },
    {
        path: 'bidding-settings',
        component: BiddingComponent,
        canActivate: [AuthGuard, OiaGuard],
        children: [
            {path: '', redirectTo: 'view-rounds', pathMatch: 'full'},
            {path: 'view-rounds', component: ViewRoundsComponent},
            {path: 'modify-rounds', component: ModifyRoundsComponent},
            {path: 'results', component: ResultsComponent},
            {path: 'processing-output', component: ProcessingOutputComponent},
        ]
    },
    {
        path: 'bidding-settings-ec',
        component: BiddingComponent,
        canActivate: [AuthGuard, EcGuard],
        children: [
            {path: '', redirectTo: 'view-rounds', pathMatch: 'full'},
            {path: 'view-rounds', component: ViewRoundsComponent},
            {path: 'modify-rounds', component: ModifyRoundsComponent},
            {path: 'results', component: ResultsComponent},
            {path: 'processing-output', component: ProcessingOutputComponent},
            {path: 'round-two', component: RoundTwoComponent},
        ]
    },
    {
        path: 'bidding-rounds',
        component: BiddingRoundsComponent,
        canActivate: [AuthGuard, OutgoingStudentGuard],
        children: [
            {path: '', redirectTo: 'practice-round', pathMatch: 'full'},
            {path: 'practice-round', component: PracticeRoundComponent},
            {path: 'round-1', component: RoundOneComponent},
            {path: 'round-2', component: BiddingRoundTwoComponent},
            {path: 'round-3', component: RoundThreeComponent},
            // {path: 'round-4', component: RoundFourComponent},
        ]
    },
    {
        path: 'confirmation',
        component: ConfirmationComponent,
        canActivate: [AuthGuard, OutgoingStudentGuard],
        children: [
            {path: '', redirectTo: 'practice-round', pathMatch: 'full'},
            {path: 'practice-round', component: ConfirmationPracticeRoundComponent},
            {path: 'round-1', component: ConfirmationRoundOneComponent},
            {path: 'round-2', component: ConfirmationRoundTwoComponent},
            {path: 'round-3', component: ConfirmationRoundThreeComponent},
            // {path: 'round-4', component: ConfirmationRoundFourComponent},
        ]
    },
    {
        path: 'feedback',
        canActivate: [AuthGuard, OutgoingStudentGuard],
        component: FeedbackFormComponent,
    },
    {
        path: 'utility',
        component: UtilityComponent,
        canActivate: [AuthGuard, OiaGuard],
        children: [
            {path: '', redirectTo: 'actions', pathMatch: 'full'},
            {path: 'announcements', component: AnnouncementsComponent},
            {path: 'email-templates', component: EmailTemplatesComponent},
            {path: 'documents', component: DocumentsComponent},
            {path: 'actions', component: ActionsComponent}
        ]
    },
    /*{
        path: 'utility-ec',
        component: UtilityComponent,
        canActivate: [AuthGuard, EcGuard],
        children: [
            {path: '', redirectTo: 'actions', pathMatch: 'full'},
            {path: 'announcements', component: AnnouncementsComponent},
            {path: 'email-templates', component: EmailTemplatesComponent},
            {path: 'documents', component: DocumentsComponent},
            {path: 'actions', component: ActionsComponent}
        ]
    },*/
    {
        path: 'reports',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: ReportsComponent,
    },
    {
        path: 'reports-ec',
        canActivate: [AuthGuard, EcGuard],
        component: ReportsComponent,
    },
    {
        path: 'registration-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: RegistrationReportsComponent,
    },
    {
        path: 'practice-round-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: PracticeRoundReportsComponent,
    },
    {
        path: 'round-one-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: RoundOneReportsComponent,
    },
    {
        path: 'round-two-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: RoundTwoReportsComponent,
    },
    {
        path: 'final-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: FinalReportsComponent,
    },
    {
        path: 'diversity-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: DiversityReportsComponent,
    },
     {
        path: 'dream-university-reports/:id',
        canActivate: [AuthGuard, OiaOrEcGuard],
        component: DreamUniversityReportComponent,
    },
    {
        path: 'no-access',
        component: AccessDeniedComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'reset-password',
        component: ForgetPasswordComponent,
    },
    {
        path: '**',
        component: PageNotFoundComponent,
    }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
